import { Button, Label, Spinner, Textarea } from 'flowbite-react';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { rejectCandidate } from 'src/apis/application';
import { useToast } from 'src/context/ToastProvider';
import { RejectCandidateInput } from 'types';

const RecruiterCandidateRejectCandidate = ({
	userId,
	userName,
	onSubmit,
	onFinish,
	isLoading,
	positionId,
}: {
	userId?: string;
	userName?: string;
	isLoading?: boolean;
	positionId?: string;
	onFinish?: () => void;
	onSubmit?: (data: RejectCandidateInput) => void;
}) => {
	const toast = useToast();
	const queryClient = useQueryClient();
	const [feedback, setFeedback] = React.useState('');

	const rejectCandidateFn = useMutation(['rejectCandidate'], rejectCandidate, {
		onSuccess() {
			toast({
				title: `Rejected ${userName}`,
				type: 'success',
			});
			console.log('{ queryKey:', { queryKey: ['getRecommendationsForPosition'], exact: false });
			setTimeout(() => {
				queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
			}, 100);
			setFeedback('');
			onFinish && onFinish();
		},
		onError(error: Error) {
			toast({
				title: `Error occured ${error.message}`,
				type: 'error',
			});
		},
	});
	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				if (onSubmit) onSubmit({ userId: userId ?? '', positionId: positionId ?? '', remarks: feedback });
				else rejectCandidateFn.mutate({ userId: userId ?? '', positionId: positionId ?? '', remarks: feedback });
			}}
		>
			<div className="mb-[8px] flex justify-between items-end">
				<div>
					<Label>{'Feedback '}</Label>
					<span className="text-[red]">*</span>

					<span className="italic text-xs text-[#6B7280] ">{(feedback?.length || 0) + ' / ' + 640}</span>
				</div>
			</div>

			<Textarea
				name="message"
				value={feedback}
				maxLength={640}
				placeholder="Write text here ..."
				className="border bg-white dark:text-white dark:border-[#4B5563] min-h-[185px] dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
				onChange={e => {
					setFeedback(e.target.value);
				}}
			/>

			<Button
				type="submit"
				className="w-full mt-[20px] bg-[#7777E7]"
				color="purplePlaced"
				disabled={rejectCandidateFn.isLoading || isLoading || !feedback}
			>
				{rejectCandidateFn.isLoading || isLoading ? <Spinner /> : 'Reject'}
			</Button>
		</form>
	);
};

export default RecruiterCandidateRejectCandidate;
